import { render, staticRenderFns } from "./WebPage.vue?vue&type=template&id=d05c1732&scoped=true&"
import script from "./WebPage.vue?vue&type=script&lang=js&"
export * from "./WebPage.vue?vue&type=script&lang=js&"
import style0 from "./WebPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WebPage.vue?vue&type=style&index=1&id=d05c1732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05c1732",
  null
  
)

export default component.exports